// extracted by mini-css-extract-plugin
export var footer = "_jo-0";
export var inherit = "_jo-1";
export var input = "_jo-2";
export var modalContent = "_jo-3";
export var quillEditor = "_jo-4";
export var subtitle = "_jo-5";